var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"range":""},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})
}
var staticRenderFns = []

export { render, staticRenderFns }